module.exports = __webpack_public_path__ + "static/media/3a.85bace2d.jpg";